import { render } from "./ValuesVectorChart.vue?vue&type=template&id=15f8171b&scoped=true"
import script from "./ValuesVectorChart.vue?vue&type=script&lang=js"
export * from "./ValuesVectorChart.vue?vue&type=script&lang=js"

import "./ValuesVectorChart.vue?vue&type=style&index=0&id=15f8171b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f8171b"]])

export default __exports__